import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axiosInstance from "../../utils/axiosInstance";

export const fetchActivities = createAsyncThunk(
  "notification/fetchActivities",
  async (squadId) => {
    const response = await axiosInstance(
      `/activities/?include=reference&squad_id=${squadId}`,
      "get",
    );
    return response.data.data;
  },
);

export const fetchActivitiesByCapsuleAndSquad = createAsyncThunk(
  "notification/fetchActivitiesByCapsuleAndSquad",
  async (data) => {
    const response = await axiosInstance(
      `/activities/?include=reference&squad_id=${data.squadId}&user_id=${data.userId}&capsule_id=${data.capsuleId}`,
      "get",
    );
    return response.data.data;
  },
);

export const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    activities: [],
    activitiesByCapsuleAndSquad: [],
    pendingDeliverableGrade: null,
  },
  reducers: {
    addActivity: (state, action) => {
      const updateActivity = {
        user_id: action.payload.user_id,
        squad_id: action.payload.squad_id,
        activity_type: action.payload.activity_type,
        created_at: JSON.parse(action.payload.info).created_at,
        updated_at: JSON.parse(action.payload.info).created_at,
        points_earned: action.payload.points,
      };
      state.activities.push(updateActivity);
    },
    setDeliverableGradeNotification: (state, action) => {
      state.pendingDeliverableGrade = action.payload;
    },
    clearDeliverableGradeNotification: (state) => {
      state.pendingDeliverableGrade = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchActivities.fulfilled, (state, action) => {
      state.activities = action.payload;
    });
    builder.addCase(
      fetchActivitiesByCapsuleAndSquad.fulfilled,
      (state, action) => {
        state.activitiesByCapsuleAndSquad = action.payload;
      },
    );
  },
});

export const {
  addActivity,
  setDeliverableGradeNotification,
  clearDeliverableGradeNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
